import { render, staticRenderFns } from "./tariffTable.vue?vue&type=template&id=3fda6a69&"
import script from "./tariffTable.vue?vue&type=script&lang=js&"
export * from "./tariffTable.vue?vue&type=script&lang=js&"
import style0 from "./tariffTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports